export default __webpack_public_path__ + "static/media/darkPurpleKustomize.1dbd9820.svg";